export enum PatientJourneyStage {
    BeforeTreatment = 1,
    OnTreatment = 2,
    AfterTreatment = 3,
    RestartingTreatment = 4,
    TreatmentDisruption = 5,
    NoClearJourneyStage = 6,
}
